module.exports = __webpack_public_path__ + "static/Banner-39-194275ba70e99e712bb0e1803da1d0a9.png";